/**
 * A/B Test — Cart reservation countdown
 * Toggle: body[data-cart-reservation-ab="true|false"]
 *   - true  (Variant B / test)    -> cart is reserved for N and auto-clears on expiry
 *   - false (Variant A / control) -> no reservation, no countdown, no auto-clear
 */
(function () {
  'use strict';

  var ATTR = 'data-cart-reservation-ab';
  var STORAGE_KEY = 'aerless_cart_reserved_until';
  var RESERVATION_MS = 10 * 60 * 1000;
  var tickTimer = null;
  var isClearing = false;

  function isAbEnabled() {
    return document.body.getAttribute(ATTR) === 'true';
  }

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchCart() {
    return fetch(getRoot() + 'cart.js').then(function (res) {
      return res.json();
    });
  }

  function getExpiry() {
    var value = window.localStorage.getItem(STORAGE_KEY);
    return value ? parseInt(value, 10) : null;
  }

  function setExpiry(timestamp) {
    window.localStorage.setItem(STORAGE_KEY, String(timestamp));
  }

  function clearExpiry() {
    window.localStorage.removeItem(STORAGE_KEY);
  }

  function formatTime(remainingMs) {
    var totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function getReservationElement() {
    return document.querySelector('cart-drawer .cart-drawer__reservation');
  }

  function updateDisplay(expiry) {
    var reservation = getReservationElement();
    if (!reservation) return;

    var timeEl = reservation.querySelector('.cart-drawer__reservation-time');
    if (!expiry) {
      reservation.hidden = true;
      return;
    }

    var remaining = expiry - Date.now();
    if (remaining <= 0) {
      reservation.hidden = true;
      return;
    }

    reservation.hidden = false;
    if (timeEl) {
      timeEl.textContent = formatTime(remaining);
    }
  }

  function stopTicking() {
    if (tickTimer) {
      window.clearInterval(tickTimer);
      tickTimer = null;
    }
  }

  function startTicking() {
    if (tickTimer) return;

    tickTimer = window.setInterval(function () {
      if (!isAbEnabled()) {
        stopTicking();
        updateDisplay(null);
        return;
      }

      var expiry = getExpiry();
      if (!expiry) {
        stopTicking();
        updateDisplay(null);
        return;
      }

      var remaining = expiry - Date.now();
      if (remaining <= 0) {
        stopTicking();
        clearCart();
        return;
      }

      updateDisplay(expiry);
    }, 1000);
  }

  function closeCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.hide === 'function') {
      cartDrawer.hide();
    }
  }

  function clearCart() {
    if (isClearing) return Promise.resolve();

    isClearing = true;
    stopTicking();
    clearExpiry();
    updateDisplay(null);
    closeCartDrawer();

    return fetch(getRoot() + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {})
      .finally(function () {
        isClearing = false;
      });
  }

  function syncReservation() {
    // Variant A (control): reservation disabled — never start a timer, keep banner hidden.
    if (!isAbEnabled()) {
      stopTicking();
      clearExpiry();
      updateDisplay(null);
      return Promise.resolve();
    }

    if (isClearing) return Promise.resolve();

    return fetchCart()
      .then(function (cart) {
        if (!cart || !cart.item_count) {
          clearExpiry();
          stopTicking();
          updateDisplay(null);
          return;
        }

        var now = Date.now();
        var expiry = getExpiry();

        if (!expiry) {
          expiry = now + RESERVATION_MS;
          setExpiry(expiry);
        } else if (now >= expiry) {
          return clearCart();
        }

        updateDisplay(expiry);
        startTicking();
      })
      .catch(function () {});
  }

  function init() {
    syncReservation();

    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === ATTR) syncReservation();
      });
    });
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: [ATTR] });

    document.addEventListener('cart:change', syncReservation);
    document.addEventListener('cart:refresh', syncReservation);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        syncReservation();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.AerlessCartReservationAb = {
    refresh: syncReservation,
    isEnabled: isAbEnabled
  };
})();
